var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormCandidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80.000000pt",
    height: "81.000000pt",
    viewBox: "0 0 80.000000 81.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,81.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 410 l0 -350 260 0 260 0 0 258 0 257 -93 93 -92 92 -168 0 -167 0 0 -350z m310 230 l0 -90 90 0 90 0 0 -230 0 -230 -230 0 -230 0 0 320 0 320 140 0 140 0 0 -90z m95 0 l59 -60 -62 0 -62 0 0 60 c0 33 1 60 3 60 1 0 29 -27 62 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 533 c-18 -18 0 -23 83 -23 73 0 90 3 90 15 0 12 -16 15 -83 15 -46 0 -87 -3 -90 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 455 c0 -13 27 -15 180 -15 153 0 180 2 180 15 0 13 -27 15 -180 15 -153 0 -180 -2 -180 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 385 c0 -13 27 -15 180 -15 153 0 180 2 180 15 0 13 -27 15 -180 15 -153 0 -180 -2 -180 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 315 c0 -13 27 -15 180 -15 153 0 180 2 180 15 0 13 -27 15 -180 15 -153 0 -180 -2 -180 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 245 c0 -13 27 -15 180 -15 153 0 180 2 180 15 0 13 -27 15 -180 15 -153 0 -180 -2 -180 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 175 c0 -13 27 -15 180 -15 153 0 180 2 180 15 0 13 -27 15 -180 15 -153 0 -180 -2 -180 -15z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormCandidate);
export default __webpack_public_path__ + "static/media/form_candidate.92571ef4fa7a84d1c9f73f87644661d8.svg";
export { ForwardRef as ReactComponent };